import React from 'react';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import { InputFields } from './components/InputFields';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import classNames from 'classnames';
import style from './BpaForm.module.scss';

interface IProps {
	isVisible: boolean;
}

export const BpaForm: React.FC<IProps> = React.memo(({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<WithAdditionalValidationState>
				<InputFields />
			</WithAdditionalValidationState>
			<ModalWindows />
		</div>
	);
});
